import { ExDoDwReq, ExDoDwDef } from "../../type/report/ex-do-dw";

export class ExDoDwAdapter {
  static toInputDTO(req: ExDoDwReq): any {
    return {
      name: req.name,
      intervention_variable: req.intervention_variable,
      target_variable: req.target_variable,
      subgrouping_conditions: req.subgrouping_conditions,
    };
  }

  static toOutputDTO(res: any): ExDoDwDef {
    return res;
  }
}
